import React from 'react'

import { NotificationBarType } from 'common/core/constants/NotificationBarType'

import {
  MetaDeletionNotification,
  MetaDeletionNotificationType,
  MetaDeletionPayload,
  MetaDeletionReadyNotification,
  NotificationRemoveType,
} from '../NotifyInterfaces'

import { MetaDeletionChannelNotification } from './MetaDeletionChannelNotification'
import { MetaDeletionContactsNotification } from './MetaDeletionContactsNotification'
import { MetaDeletionSignInNotification } from './MetaDeletionSignInNotification'
import { MetaDeletionSignInWithFallbackNotification } from './MetaDeletionSignInWithFallbackNotification'

const getRender = (
  message: MetaDeletionNotification['message'],
  data: MetaDeletionPayload,
): MetaDeletionReadyNotification['render'] => {
  switch (message) {
    case MetaDeletionNotificationType.META_DELETION_CHANNEL_D0:
      return () => <MetaDeletionChannelNotification day={0} data={data} />
    case MetaDeletionNotificationType.META_DELETION_CHANNEL_D15:
      return () => <MetaDeletionChannelNotification day={15} data={data} />
    case MetaDeletionNotificationType.META_DELETION_CHANNEL_D27:
      return () => <MetaDeletionChannelNotification day={27} data={data} />
    case MetaDeletionNotificationType.META_DELETION_ONLY_SIGN_IN_D0:
      return () => <MetaDeletionSignInNotification day={0} data={data} />
    case MetaDeletionNotificationType.META_DELETION_ONLY_SIGN_IN_D15:
      return () => <MetaDeletionSignInNotification day={15} data={data} />
    case MetaDeletionNotificationType.META_DELETION_ONLY_SIGN_IN_D27:
      return () => <MetaDeletionSignInNotification day={27} data={data} />
    case MetaDeletionNotificationType.META_DELETION_SIGN_IN_WITH_FALLBACK_D0:
      return () => <MetaDeletionSignInWithFallbackNotification day={0} data={data} />
    case MetaDeletionNotificationType.META_DELETION_SIGN_IN_WITH_FALLBACK_D15:
      return () => <MetaDeletionSignInWithFallbackNotification day={15} data={data} />
    case MetaDeletionNotificationType.META_DELETION_SIGN_IN_WITH_FALLBACK_D27:
      return () => <MetaDeletionSignInWithFallbackNotification day={27} data={data} />
    case MetaDeletionNotificationType.META_DELETION_CONTACTS:
      return () => <MetaDeletionContactsNotification />
  }
}

export const parseMetaDeletionNotification = (
  notification: MetaDeletionNotification,
): MetaDeletionReadyNotification => {
  return {
    ...notification,
    type: NotificationBarType.WARNING,
    removeType: NotificationRemoveType.ALWAYS,
    render: getRender(notification.message, notification.data),
  }
}
